module.exports = __webpack_public_path__ + "img/question.9a32fdc1.svg";